import 'regenerator-runtime/runtime';

const invoiceLinks = document.querySelectorAll('.js-invoice-link');

if (invoiceLinks) {
  invoiceLinks.forEach((item) => {
    item.addEventListener('click', handleInvoiceDownload);
  });
}

// Handle invoice download from Holded.
async function handleInvoiceDownload(e) {
  const button = e.currentTarget;
  const invoiceId = button.getAttribute('data-invoice-id');
  const invoiceNumber = button.getAttribute('data-invoice-number');

  try {
    button.classList.add('is-loading');

    const response = await fetch(holded_object.admin_ajax_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: new URLSearchParams({
        action: 'holded_invoice_download_request',
        _download_nonce: holded_object.ajax_nonce,
        invoice: invoiceId,
      }),
      credentials: 'same-origin',
    });
    const data = await response.json();
    if (data.success) {
      downloadPDF(data.data.invoice, invoiceNumber);
      button.classList.remove('is-loading');
    } else {
      button.classList.remove('is-loading');
      const err = new Error(data.data.error_message);
      throw err;
    }
  } catch (error) {
    alert(error);
  }
}

function downloadPDF(pdf, name) {
  const linkSource = `data:application/pdf;base64,${pdf}`;
  const downloadLink = document.createElement('a');
  const fileName = `Factura ${name}.pdf`;

  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}
